import { useRef } from "react"
import { FaPaperclip } from "react-icons/fa"
import { FaXmark } from "react-icons/fa6"
import useT from "utils/hooks/useT"

import "./index.scss"

const MAX_FILE_COUNT = 3

export function FileAttachmentButton({ files, onAddFiles, disabled }) {
  const { t } = useT("common")
  const inputRef = useRef(null)

  const handleClick = () => {
    if (!disabled) inputRef.current?.click()
  }

  const handleChange = (e) => {
    const selected = Array.from(e.target.files || [])
    e.target.value = ""
    if (selected.length > 0) onAddFiles(selected)
  }

  return (
    <>
      <button
        type="button"
        className="file-attachment-button"
        onClick={handleClick}
        disabled={disabled || files.length >= MAX_FILE_COUNT}
        aria-label={t("attachFile")}
        title={t("attachFile")}
      >
        <FaPaperclip />
      </button>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept=".pdf,.docx,.txt,.csv,image/*"
        onChange={handleChange}
        hidden
      />
    </>
  )
}

export function FileAttachmentChips({ files, onRemoveFile }) {
  const { t } = useT("common")

  if (files.length === 0) return null

  return (
    <div className="file-attachment-chips">
      {files.map((file, index) => (
        <span key={index} className="file-chip">
          <FaPaperclip size={10} />
          <span className="file-chip-name" title={file.name}>{file.name}</span>
          <button
            type="button"
            className="file-chip-remove"
            onClick={() => onRemoveFile(index)}
            aria-label={t("removeFile")}
          >
            <FaXmark />
          </button>
        </span>
      ))}
    </div>
  )
}

// Default export for backwards compatibility
export default function FileAttachment({ files, onAddFiles, onRemoveFile, disabled }) {
  return (
    <div className="file-attachment">
      <FileAttachmentButton files={files} onAddFiles={onAddFiles} disabled={disabled} />
      <FileAttachmentChips files={files} onRemoveFile={onRemoveFile} />
    </div>
  )
}
